import {
  // CNDAPIListSchema,
  CNDAPICallAuditDetailsFormSchema,
  CNDAPIProxyResponseSchema,
  ICNDAPIAuditCallDetailsForm,
  ICNDAPIForm,
} from 'src/models/cndapi.model';
import { httpClient } from 'src/libraries/http.library';

const http = httpClient();

const cndService = {
  // Call CND API via internal NTLM proxy (server/cndApiCall).
  // The proxy performs the NTLM handshake server-side using service-account
  // credentials so the browser never needs to handle NTLM directly.
  CallCNDApi: async (cndData: ICNDAPIForm) => {
    return http.post('cndApiCall', cndData, CNDAPIProxyResponseSchema);
  },

  // Save CND API call audit details in Aviation API DB
  CreateCNDAPIAuditCallDetailsPOST: async (data: ICNDAPIAuditCallDetailsForm) => {
    return http.post('cndApiAuditCalls', data, CNDAPICallAuditDetailsFormSchema);
  },
};

export default cndService;
